module.exports = __webpack_public_path__ + "static/media/calculator.6e5334f7.svg";